import { render, staticRenderFns } from "./UIPercent.vue?vue&type=template&id=7fe681f4&"
import script from "./UIPercent.vue?vue&type=script&lang=js&"
export * from "./UIPercent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports